<template>
  <div>
    <div class="custom-card-header">
      <!-- <div class="filterButtonPosition">
        <div class="display-flex">
          <f7-button outline @click="newAlert">
            {{ $t('alert.new') }}
          </f7-button>
          <f7-button
            fill
            class="whiteFontColor button-filter"
            panel-toggle="right"
          >
            <span class="ic-filter"></span> {{ $t('filter') }}
          </f7-button>
        </div>
      </div> -->
    </div>
    <DxDataGrid
      :data-source="store"
      :show-borders="false"
      :show-column-lines="false"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :column-auto-width="true"
      :show-column-headers="true"
      :show-colon="false"
      :remote-operations="{
        paging: true,
        filtering: true,
        sorting: false,
      }"
      :hover-state-enabled="false"
      :show-row-lines="false"
      :row-alternation-enabled="false"
      class="custom-grid custom-alerts-samplesTable"
      :auto-navigate-to-focused-row="autoFocus"
      @contentReady="init"
      @focused-row-changed="focusedRowChanged"
      @toolbar-preparing="onToolbarPreparing($event)"
    >
      <DxScrolling mode="standard" />
      <DxStateStoring
        :enabled="true"
        type="localStorage"
        storage-key="alertsSampleTable"
      />
      <DxPaging :page-size="10" />
      <DxPager
        :show-page-size-selector="true"
        :allowed-page-sizes="[5, 10, 20]"
        :show-info="true"
        info-text="{2} items"
        :visible="true"
      />

      <DxSearchPanel :visible="true" :placeholder="$t('search')" />

      <DxColumn
        data-field="atc"
        :caption="$t('alert.area')"
        alignment="left"
        :allow-header-filtering="false"
      />

      <DxColumn
        data-field="sample_type"
        :caption="$t('agronomySample.summary.sampleType')"
        alignment="left"
        :allow-header-filtering="false"
      />
      <DxColumn
        data-field="farm"
        :caption="$t('foodSamples.samplingSite')"
        alignment="left"
        :allow-header-filtering="false"
      />
      <DxColumn
        data-field="parcel"
        :caption="$t('environmentSamples.samplingPoint')"
        alignment="left"
        :allow-header-filtering="false"
      />
      <DxColumn
        data-field="created_at"
        :caption="$t('alert.creationDate')"
        alignment="left"
        data-type="date"
        :format="$helpers.getDateFormat(company) + ' HH:mm:ss'"
        sort-order="desc"
        :allow-header-filtering="false"
      />
      <DxColumn
        data-field="updated_at"
        :caption="$t('alert.modificationDate')"
        alignment="left"
        data-type="date"
        :format="$helpers.getDateFormat(company) + ' HH:mm:ss'"
        :allow-header-filtering="false"
      />
      <DxColumn
        data-field="n_superior_lmr_parameters"
        :caption="$t('alert.parameters')"
        alignment="left"
        :allow-header-filtering="false"
      />

      <DxColumn
        data-field=""
        :caption="'Nº ' + $t('chains')"
        alignment="left"
        :allow-header-filtering="false"
        cell-template="cellTemplateNrRetailers"
      />
      <DxColumn
        data-field=""
        :caption="$t('chains')"
        alignment="left"
        :allow-header-filtering="false"
        cell-template="cellTemplateRetailers"
      />
      <DxColumn
        data-field="value_report"
        :caption="$t('agronomySample.summary.description')"
        alignment="left"
        :allow-header-filtering="false"
      />

      <DxColumn
        data-field=""
        :caption="$t('status')"
        alignment="left"
        :fixed="true"
        fixed-position="right"
        :allow-header-filtering="false"
        cell-template="cellTemplateStatus"
      />
      <DxColumn
        :buttons="editButtons"
        :fixed="true"
        fixed-position="right"
        type="buttons"
        width="90"
      />

      <template #cellTemplateStatus="{ data }">
        <div>
          <DxSwitch
            :value="data.data.is_active"
            @valueChanged="
              () => {
                updateState(
                  'status',
                  {
                    newState: !data.data.is_active,
                    id: data.data.id,
                  },
                  data
                );
              }
            "
          />
        </div>
      </template>
      <template #cellTemplateNrRetailers="{ data }">
        <div>
          <div v-if="data.data.retailers_num">
            {{ data.data.retailers_num }}
          </div>
          <div v-else>0</div>
        </div>
      </template>
      <template #cellTemplateRetailers="{ data }">
        <div>
          <div v-if="data.data.retailers">
            {{ getRetailers(data.data.retailers) }}
          </div>
          <div v-else></div>
        </div>
      </template>
    </DxDataGrid>

    <NewAlertPopup
      v-if="showNewAlertSamplePopup"
      :params="params"
      :edit-data="editData"
    />
  </div>
</template>
<script>
import {
  DxDataGrid,
  DxColumn,
  DxSearchPanel,
  DxStateStoring,
  DxPager,
  DxPaging,
  DxScrolling,
} from 'devextreme-vue/data-grid';

import { DxSwitch } from 'devextreme-vue/switch';
import { mapActions, mapGetters, mapState } from 'vuex';

import NewAlertPopup from '@/components/Alerts/Settings/NewAlertPopup/Sample/index.vue';
import EventBus from '@/services/event-bus';
import notify from 'devextreme/ui/notify';
import Helpers from '@/js/helpers';
import { NOTIFY_TIME_LONG } from '@/js/constants';
import iconTrash from '@/static/icons/ic_trash_new.svg';
import iconEdit from '@/static/icons/ic_edit_new.svg';
import iconCopy from '@/static/icons/ic_copy_new.svg';

import Api from '@/services/Api';

export default {
  name: 'SampleTable',
  components: {
    DxDataGrid,
    DxColumn,
    DxSearchPanel,
    DxStateStoring,
    DxPager,
    DxPaging,
    DxScrolling,
    DxSwitch,
    NewAlertPopup,
  },
  props: {
    store: {
      type: Object,
      default: () => {},
    },
    params: {
      type: Object,
      default: () => {},
    },
    showSwitch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editButtons: [
        {
          icon: iconCopy,
          cssClass: 'grid-button-icon',
          onClick: this.duplicateConfirm,
        },
        {
          icon: iconEdit,
          cssClass: 'grid-button-icon ic-edit-new',
          onClick: this.editAlert,
        },
        {
          icon: iconTrash,
          cssClass: 'grid-button-icon',
          onClick: this.deleteConfirm,
        },
      ],
      editData: {},
      changedFocused: false,
      autoFocus: !Helpers.isEmptyObject(this.params),
      showNotificationsSwitch: true,
      switchValue: false,
      firstLoad: true,
    };
  },
  computed: {
    ...mapState('alerts', ['showNewAlertSamplePopup']),
    ...mapState('alertsSample', ['focusedRowKey']),
    ...mapState('contact', ['company', 'address']),
    ...mapGetters('user', ['userProfile']),
  },
  methods: {
    onToolbarPreparing(e) {
      const toolbarItems = e.toolbarOptions.items;
      e.toolbarOptions.elementAttr = {
        class: 'custom-simple-toolbar',
      };
      toolbarItems.forEach((item) => {
        if (item.name === 'searchPanel') {
          item.location = 'before';
        }
      });

      // Añadir el selector de agrupaciones
      toolbarItems.push({
        name: 'Filtros',
        location: 'before',
        widget: 'dxButton',
        locateInMenu: 'never',
        options: {
          text: this.$t('filter'),
          icon: '././static/icons/ic_filter.svg',
          width: 115,
          elementAttr: {
            class: 'btn-filtrar',
          },
          onClick: () => {
            this.$f7.panel.open('right');
          },
        },
      });

      // SE OCULTAN POR AHORA LOS FILTROS BURBUJAS DE ALERTAS, EN SIGUIENTES FASES SE EVALUARÁ SI INCLUIRLOS
      // // Boton para Filtrar Activas
      // toolbarItems.push({
      //   name: 'Activas',
      //   location: 'before',
      //   widget: 'dxButton',
      //   locateInMenu: 'never',
      //   options: {
      //     text: 'Activas', // FALTA INTERNACIONALIZAR ESTE TEXTO CUANDO SE ACTIVE
      //     width: 105,
      //     elementAttr: {
      //       class: 'filtrosBotones',
      //     },
      //     onClick: () => {
      //       // console.log('Botón Filtrar presionado');
      //     },
      //   },
      // });

      // // Boton para Filtrar Inactivas
      // toolbarItems.push({
      //   name: 'Inactivas',
      //   location: 'before',
      //   widget: 'dxButton',
      //   locateInMenu: 'never',
      //   options: {
      //     text: 'Inactivas', // FALTA INTERNACIONALIZAR ESTE TEXTO CUANDO SE ACTIVE
      //     width: 105,
      //     elementAttr: {
      //       class: 'filtrosBotones',
      //     },
      //     onClick: () => {
      //       // console.log('Botón Filtrar presionado');
      //     },
      //   },
      // });

      // // Boton para Filtrar Último mes
      // toolbarItems.push({
      //   name: 'Último mes',
      //   location: 'before',
      //   widget: 'dxButton',
      //   locateInMenu: 'never',
      //   options: {
      //     text: this.$t('lastMonth'),
      //     width: 115,
      //     elementAttr: {
      //       class: 'filtrosBotones',
      //     },
      //     onClick: () => {
      //       // console.log('Botón Filtrar presionado');
      //     },
      //   },
      // });

      // Boton para Nueva alerta
      toolbarItems.push({
        location: 'after',
        widget: 'dxButton',
        locateInMenu: 'never',
        options: {
          text: this.$t('alert.new'),
          elementAttr: {
            class: 'botones-registrar',
          },
          onClick: () => {
            this.newAlert();
          },
        },
      });

      // Boton por estado
      toolbarItems.push({
        name: 'Por estado',
        location: 'after',
        widget: 'dxSelectBox',
        locateInMenu: 'never',
        visible: false,
        options: {
          placeholder: this.$t('byStatus'),
          elementAttr: {
            class: 'btn-estado',
          },
          dataSource: '',
          displayExpr: '',
          valueExpr: '', // o según el identificador
          dropDownButtonTemplate() {
            return `
          <div class="dropdown-button">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 14.677C11.8795 14.677 11.7673 14.6577 11.6635 14.6192C11.5597 14.5807 11.4609 14.5147 11.3673 14.4212L6.873 9.927C6.73467 9.7885 6.66384 9.61441 6.6605 9.40475C6.65734 9.19525 6.72817 9.018 6.873 8.873C7.018 8.72816 7.19367 8.65575 7.4 8.65575C7.60634 8.65575 7.782 8.72816 7.927 8.873L12 12.9462L16.073 8.873C16.2115 8.73466 16.3856 8.66383 16.5953 8.6605C16.8048 8.65733 16.982 8.72816 17.127 8.873C17.2718 9.018 17.3443 9.19366 17.3443 9.4C17.3443 9.60633 17.2718 9.782 17.127 9.927L12.6328 14.4212C12.5391 14.5147 12.4403 14.5807 12.3365 14.6192C12.2327 14.6577 12.1205 14.677 12 14.677Z" fill="#00346A"/>
            </svg>
          </div>
      `;
          },
        },
      });
    },
    onValueChanged(e) {
      const changeTo = e.value;

      try {
        if (changeTo) {
          Api.createReceptionAlert(
            { contactCode: this.userProfile.code },
            this.company,
            this.address
          );
        } else {
          Api.deleteReceptionAlert(
            { contactCode: this.userProfile.code },
            this.company,
            this.address
          );
        }

        this.switchValue = e.value;
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(
                JSON.parse(error.message).error
              )
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );

        this.switchValue = !e.value;
      }
    },
    getRetailers(retailers) {
      const replace = retailers.toString().replace(/[\[\]]/g, '');
      const array = replace.split(',');
      return array
        .map((el) => {
          return el.replaceAll("'", '');
        })
        .toString();
    },
    init(e) {
      e.component.option('focusedRowKey', this.focusedRowKey);
      this.changedFocused = true;
    },
    focusedRowChanged(row) {
      if (!row.row) return;

      if (this.changedFocused) {
        if (Helpers.isEmptyObject(this.params)) {
          this.setFocusedRowKey(row.row.data.id);
        }
      }
    },
    async updateState(type, data, grid) {
      const updatedRow = await this.store.update(type, data);

      grid.row.data.is_active = updatedRow.is_active;
      grid.component.repaintRows(grid.rowIndex);
    },
    newAlert() {
      this.editData = {};
      this.setShowNewAlertSamplePopup(true);
    },
    editAlert(e) {
      this.editData.isEditing = true;
      this.editData.data = {};

      this.editData.data.id = e.row.data.id;
      this.editData.data.area = e.row.data.atc;
      this.editData.data.sampleType = e.row.data.sample_type;
      this.editData.data.farm = e.row.data.farm;
      this.editData.data.parcel = e.row.data.parcel;
      this.editData.data.valueReport = e.row.data.value_report;
      this.editData.data.nrSuperiorParams =
        e.row.data.n_superior_lmr_parameters;
      this.editData.data.retailersNum = e.row.data.retailers_num || 0;
      this.editData.data.retailers = e.row.data.retailers || [];
      this.editData.data.study = e.row.data.study || '';
      this.editData.data.sendingNotifications =
        e.row.data.sending_notifications || false;
      this.setShowNewAlertSamplePopup(true);
    },
    applyFramework7DialogTexts() {
      if (!this.$f7) return;

      this.$f7.params.dialog.buttonCancel = this.$t('cancel');
      this.$f7.params.dialog.buttonOk = this.$t('samplesRegister.ok');
    },
    deleteConfirm(e) {
      this.applyFramework7DialogTexts();
      this.$f7.dialog.confirm(
        `${this.$t('alert.deleteConfirm')}`,
        async () => {
          const { id } = e.row.data;

          try {
            notify(
              {
                message: this.$t('alert.deleting'),
                width: 450,
              },
              'info',
              2000
            );

            await this.deleteAlert(id);

            notify(
              {
                closeOnClick: true,
                message: this.$t('alert.deleted'),
                width: 450,
              },
              'success',
              2000
            );
            EventBus.$emit('newSampleAlert', this.params);
            this.$f7.dialog.close();
          } catch (error) {
            this.$notifyDX(
              {
                message: this.$t(
                  this.$helpers.getFilteredErrorMessage(
                    JSON.parse(error.message).error
                  )
                ),
                width: 550,
              },
              'error',
              NOTIFY_TIME_LONG
            );
          }
        }
      );
    },
    duplicateConfirm(e) {
      const rowData = e.row.data;
      const data = {
        nrSuperiorParams: rowData.n_superior_lmr_parameters,
        farm: rowData.farm,
        parcel: rowData.parcel,
        atc: rowData.atc,
        retailers: rowData.retailers,
        retailers_num: rowData.retailers_num,
        sampleTypeId: rowData.sample_type_id,
        sampleType: rowData.sample_type,
        isActive: rowData.is_active,
        valueReport: rowData.value_report,
        sendingNotifications: rowData.sending_notifications,
      };

      this.applyFramework7DialogTexts();
      this.$f7.dialog.confirm(
        `${this.$t('alert.duplicateConfirm')}`,
        async () => {
          try {
            notify(
              {
                message: this.$t('alert.duplicating'),
                width: 450,
              },
              'info',
              2000
            );

            await this.duplicateAlert(data);

            notify(
              {
                closeOnClick: true,
                message: this.$t('alert.duplicated'),
                width: 450,
              },
              'success',
              2000
            );

            EventBus.$emit('newSampleAlert', this.params);
            this.$f7.dialog.close();
          } catch (error) {
            this.$notifyDX(
              {
                message: this.$t(
                  this.$helpers.getFilteredErrorMessage(
                    JSON.parse(error.message).error
                  )
                ),
                width: 550,
              },
              'error',
              NOTIFY_TIME_LONG
            );
          }
        }
      );
    },
    ...mapActions('alerts', ['setShowNewAlertSamplePopup']),
    ...mapActions('alertsSample', [
      'deleteAlert',
      'duplicateAlert',
      'setFocusedRowKey',
    ]),
  },
};
</script>
<style lang="scss">
@import './sampleTable.styles.scss';
</style>
